import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ColorizeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"colorize"}/>
}
